import Page from './page'

export default class Admin extends Page
  @defaults =
    debug: false
    name: 'Modulor__Page__Admin'
